import {Component, Injector} from '@angular/core';
import { CalendarService } from './services/calendar.service';
import {
  CalendarProfileProviders,
} from '../../../core/templates/profile-form.template.providers';
import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {BFOnFormLoadComplete, BFProfileOnSave} from "../../../core/interfaces/sdk-profile-hooks.interface";

@Component({
  selector: 'app-calendar',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: CalendarProfileProviders
})
export class CalendarComponent extends AbstractProfileFormComponent implements BFOnFormLoadComplete, BFProfileOnSave {

  constructor(protected injector: Injector,
    private calendarService: CalendarService) {
     super(injector);
  }

  fgppFormLoadComplete(): void {
    this.calendarService.setSelectedWeekendsdays();
  }

  fgppOnSave(): boolean {
    this.calendarService.convertWeekendsdaysToString();
    return true;
  }
}
